import "./design-system.css";
import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import VellaApp from "./App";
import ErrorBoundary from "./ErrorBoundary";
import { I18nProvider } from "./i18n/i18n";
import "./mobile.css";
import "./studio.css";

if (process.env.REACT_APP_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.NODE_ENV || "development",
    tracesSampleRate: 0.1,
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <ErrorBoundary>
      <I18nProvider>
        <VellaApp />
      </I18nProvider>
  </ErrorBoundary>
);
